import React from "react";
import { ShieldCheck, Truck } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

export default function AnnouncementBar() {
  const { t } = useI18n();
  return (
    <div className="bg-ink text-white" data-testid="announcement-bar">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-6 px-4 py-2 text-xs sm:text-[13px]">
        <span className="flex items-center gap-1.5"><Truck size={14} className="text-brand" /> {t("announce_shipping")}</span>
        <span className="hidden items-center gap-1.5 sm:flex"><ShieldCheck size={14} className="text-brand" /> {t("announce_protection")}</span>
      </div>
    </div>
  );
}
